<section id="content1" class="fbo-tab-content quicklink-sidebar">
    <div>
        <h5> {{'customer-service.Payment Methods' |translate}}</h5>
    </div>
   
    <div class="row table-section" *ngIf="distributorMemberId>0">
        <div class="form-group col-sm-6 margin-right-10">
            <label>
                                                {{'department-system.Country' |translate}}
                                                <span title="{{'department-system.Country' |translate}}" class="ico-help fa fa-question-circle"></span>
           </label>
            <select tabindex="0" class="form-control" (change)="onCountryChangeEvent($event.target.value)">
                     <!--<option [value]="0">--Select--</option>-->
                   <option *ngFor="let country of distributorAllowedCountries" [value]="country.isoCodeThree" [selected]="country.isoCodeThree ==distributorHomeCountryCode" >{{country.countryName}}</option>
             </select>
        </div>
        <div class="col-sm-9">
            <div>
                <label>
                    <strong>   {{'customer-service.Cards' |translate}} </strong>
                 </label>

            </div>
            <table class="table table-striped custab">
                <thead>
                    <tr>
                        <!--<th>
                            <strong>{{'customer-service.Default' |translate}}&nbsp;
                             
                            </strong>
                        </th>-->
                        <th>
                            <strong>{{'customer-service.Card Type' |translate}}&nbsp;
                                <i tabindex="0" (keyup.enter)="sortTableByColumn('cardType')" (click)="sortTableByColumn('cardType')" class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'cardType', 'fa-sort-asc': (sortColumn  == 'cardType' && !isDesc), 'fa-sort-desc': (sortColumn  == 'cardType' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                        <th>
                            <strong>{{'customer-service.Full Name' |translate}}&nbsp;
                                <i tabindex="0" (keyup.enter)="sortTableByColumn('fullName')" (click)="sortTableByColumn('fullName')" class="font-12 fa fa-sort"  [ngClass]="{'fa-sort': sortColumn != 'fullName', 'fa-sort-asc': (sortColumn  == 'fullName' && !isDesc), 'fa-sort-desc': (sortColumn  == 'fullName' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                        <th>
                            <strong>{{'customer-service.Card Number' |translate}}&nbsp;
                                <i tabindex="0" (keyup.enter)="sortTableByColumn('cardNumber')" (click)="sortTableByColumn('cardNumber')" class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'cardNumber', 'fa-sort-asc': (sortColumn  == 'cardNumber' && !isDesc), 'fa-sort-desc': (sortColumn  == 'cardNumber' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                        <th>
                            <strong>{{'customer-service.Expiration Date' |translate}}&nbsp;
                                <i tabindex="0" (keyup.enter)="sortTableByColumn('expiryDate')" (click)="sortTableByColumn('expiryDate')" class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'expiryDate', 'fa-sort-asc': (sortColumn  == 'expiryDate' && !isDesc), 'fa-sort-desc': (sortColumn  == 'expiryDate' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                        <th>
                            <strong>{{'customer-service.Note' |translate}}&nbsp;
                                <i  tabindex="0" (keyup.enter)="sortTableByColumn('note')" (click)="sortTableByColumn('note')" class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'note', 'fa-sort-asc': (sortColumn  == 'note' && !isDesc), 'fa-sort-desc': (sortColumn  == 'note' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                    </tr>
                </thead>
                <tr *ngFor="let paymentMethod of distributorCardPaymentMethods">
                    <!--<td *ngIf="paymentMethod.defaultPaymentMethod">
                        <input type="checkbox" checked=checked>
                    </td>
                    <td *ngIf="!paymentMethod.defaultPaymentMethod">
                        <input type="checkbox">
                    </td>-->
                    <td>
                        {{paymentMethod.cardType}}
                    </td>
                    <td>
                        {{paymentMethod.nameOnTheCard}}
                    </td>
                    <td>
                        {{paymentMethod.maskedCard}}
                    </td>
                    <td *ngIf="paymentMethod.expiryMonth.length === 2">
                        {{paymentMethod.expiryMonth}}/{{paymentMethod.expiryYear}}
                    </td>
                    <td *ngIf="paymentMethod.expiryMonth.length === 1">
                        0{{paymentMethod.expiryMonth}}/{{paymentMethod.expiryYear}}
                    </td>
                    <td>

                    </td>
                </tr>
                
                    <tr *ngIf="distributorCardPaymentMethods?.length===0" >
                        <td></td>
                        <td></td>
                        <td>{{'department-system.No records found' |translate}}.</td>
                        <td></td>
                        <td></td>
                    </tr>
            </table>
        </div>
        <div class="col-sm-9 margintop-10">
            <div>
                <label>
                    <strong>   {{'customer-service.e-Checks' |translate}} </strong>
                 </label>
            </div>
            <table class="table table-striped custab">
                <thead>
                    <tr>
                        <!--<th>
                            <strong>{{'customer-service.Default' |translate}}&nbsp;
                             
                            </strong>
                        </th>-->
                        <th>
                            <strong>{{'customer-service.Type' |translate}}&nbsp;
                                <i tabindex="0" (keyup.enter)="sortTableByColumn('cardType')" (click)="sortTableByColumn('cardType')" class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'cardType', 'fa-sort-asc': (sortColumn  == 'cardType' && !isDesc), 'fa-sort-desc': (sortColumn  == 'cardType' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                        <th>
                            <strong>{{'customer-service.Full Name' |translate}}&nbsp;
                                <i tabindex="0" (keyup.enter)="sortTableByColumn('fullName')" (click)="sortTableByColumn('fullName')" class="font-12 fa fa-sort"  [ngClass]="{'fa-sort': sortColumn != 'fullName', 'fa-sort-asc': (sortColumn  == 'fullName' && !isDesc), 'fa-sort-desc': (sortColumn  == 'fullName' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                        <th>
                            <strong>{{'customer-service.Account Number' |translate}}&nbsp;
                                <i tabindex="0" (keyup.enter)="sortTableByColumn('cardNumber')" (click)="sortTableByColumn('cardNumber')" class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'cardNumber', 'fa-sort-asc': (sortColumn  == 'cardNumber' && !isDesc), 'fa-sort-desc': (sortColumn  == 'cardNumber' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                        <!--<th>
                            <strong>{{'customer-service.Expiration Date' |translate}}&nbsp;
                                <i (click)="sortTableByColumn('expiryDate')" class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'expiryDate', 'fa-sort-asc': (sortColumn  == 'expiryDate' && !isDesc), 'fa-sort-desc': (sortColumn  == 'expiryDate' && isDesc) }">
                                </i>
                            </strong>
                        </th>-->
                        <th>
                            <strong>{{'customer-service.Note' |translate}}&nbsp;
                                <i  tabindex="0" (keyup.enter)="sortTableByColumn('note')" (click)="sortTableByColumn('note')" class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'note', 'fa-sort-asc': (sortColumn  == 'note' && !isDesc), 'fa-sort-desc': (sortColumn  == 'note' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                    </tr>
                </thead>
                <tr *ngFor="let paymentMethod of distributorECheckPaymentMethods">
                    <!--<td *ngIf="paymentMethod.defaultPaymentMethod">
                        <input type="checkbox" checked=checked>
                    </td>
                    <td *ngIf="!paymentMethod.defaultPaymentMethod">
                        <input type="checkbox">
                    </td>-->
                    <td>
                        {{paymentMethod.accountType}}
                    </td>
                    <td>
                        {{paymentMethod.nameOnBankAccount}}
                    </td>
                    <td>
                        Ending with {{paymentMethod.accountNumber.substr(paymentMethod.accountNumber.length-4)}}
                    </td>

                    <td>
                        {{paymentMethod.customMessage}}
                    </td>
                </tr>
             
                    <tr  *ngIf="distributorECheckPaymentMethods?.length===0" >
                        <td></td>
                        <td></td>
                        <td>{{'department-system.No records found' |translate}}.</td>
                        
                        <td></td>
                    </tr>
             
            </table>
        </div>
    </div>
</section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/paymentmethods.component.html